/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

angular
.module('prism-ui.components.data')
.factory('FileSystemResourceFactory', ($resource: JS5Function, EndPointService: JS5Object) => {
    return $resource(
        EndPointService.fileSystemEndPoint, {
        }, {
            query: {
                method: 'GET',
                url: EndPointService.fileSystemEndPoint,
                isArray: true,
                headers: {
                    Range: (request: JS5Object) => {
                        let range = request.params.range;
                        delete request.params.range;
                        return range;
                    }
                }
            },
            createFileSystem: {
                method: 'POST',
                url: EndPointService.fileSystemEndPoint
            },
            getFileSystem: {
                method: 'GET',
                url: `${EndPointService.fileSystemEndPoint}/:id`,
                params: {id: '@id'}
            },
            updateFileSystem: {
                method: 'PUT',
                url: `${EndPointService.fileSystemEndPoint}/:id`,
                params: {id: '@id'}
            },
            getFileSystemTypes: {
                method: 'GET',
                url: `${EndPointService.fileSystemEndPoint}/types`,
                isArray: true,
                headers: {
                    Range: (request: JS5Object) => {
                        let range = request.params.range;
                        delete request.params.range;
                        return range;
                    }
                }
            },
        });
});
